import { InstrumentSchema } from 'src/typings/accelerator';

const DEFAULT_INSTRUMENTS: InstrumentSchema[] = [
  {
    Instrument: 'SP-X',
    Serial: '',
    Selected: false,
  },
  {
    Instrument: 'HD-1',
    Serial: '',
    Selected: false,
  },
  {
    Instrument: 'SR-X',
    Serial: '',
    Selected: false,
  },
  {
    Instrument: 'HD-X',
    Serial: '',
    Selected: false,
  },
];

export const getDefaultInstruments = (): InstrumentSchema[] => {
  return DEFAULT_INSTRUMENTS.map((object) => ({ ...object }));
};
